import React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAppConfigContext } from "../context/AppConfigContext";

export default function Maintenance() {
  const queryClient = useQueryClient();
  const { config } = useAppConfigContext();

  const handleCheckAgain = () => {
    queryClient.invalidateQueries({ queryKey: ["public", "maintenance"] });
    queryClient.invalidateQueries({ queryKey: ["public", "appConfig"] });
  };

  const handleContactSupport = () => {
    window.location.href = `mailto:${config.supportEmail}`;
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#F9FAFB] px-6 py-12 text-center">
      <div className="w-full max-w-2xl">
        {/* Maintenance illustration */}
        <div className="mb-10 flex justify-center">
          <img
            src="/images/maintenance.svg"
            alt="Scheduled maintenance"
            className="h-auto w-full max-w-md"
          />
        </div>

        {/* Heading */}
        <h1 className="mb-4 text-3xl font-bold leading-tight text-[#1F2937] sm:text-4xl">
          Scheduled Maintenance in Progress
        </h1>

        {/* Subheading */}
        <p className="mb-6 text-lg font-semibold text-[#1F2937] sm:text-xl">
          We’re currently making improvement to provide you with a better experience.
        </p>

        {/* Description */}
        <p className="mx-auto mb-5 max-w-lg text-base leading-relaxed text-[#4B5563]">
          Our platform is temporarily unavailable while we perform essential updates
          and maintenance. During this period, some or all features may not be
          accessible.
        </p>

        {/* Apology line */}
        <p className="mx-auto mb-8 max-w-lg text-base italic leading-relaxed text-[#6B7280]">
          We apologize for any inconvenience and appreciate your patience while we work to improve the platform.
        </p>

        {/* Action buttons */}
        <div className="mx-auto mb-12 flex max-w-md flex-col gap-3">
          <button
            type="button"
            onClick={handleCheckAgain}
            className="w-full rounded-lg bg-[#61013B] px-6 py-3.5 text-base font-semibold text-white transition hover:bg-[#4d0130] focus:outline-none focus:ring-2 focus:ring-[#61013B] focus:ring-offset-2"
          >
            Check Again
          </button>
          <button
            type="button"
            onClick={handleContactSupport}
            className="w-full rounded-lg border border-[#61013B] bg-transparent px-6 py-3.5 text-base font-semibold text-[#61013B] transition hover:bg-[#61013B]/5 focus:outline-none focus:ring-2 focus:ring-[#61013B] focus:ring-offset-2"
          >
            Contact Support
          </button>
        </div>

        {/* Footer */}
        <div className="space-y-1 text-sm text-[#6B7280]">
          <p className="font-bold uppercase tracking-wide text-[#374151]">
            THANK YOU FOR YOUR PATIENCE.
          </p>
          <p>2024 Pulo Travel marketplace. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}
